import utils from "../services/utils";

let azure = require("azure-storage");
let $ = require("jquery");
let dt = require("datatables.net-bs4");

let index = {
  render: async () => {
    let view = /*html*/ `
    <div id="container" class="container">
      <div class="row text-center">
        <div class="col"><h1>Campaigns</h1></div>
      </div>
      <div class="row">
        <div class="col">
          <table id="campaigns-table" class="table table-striped table-bordered table-sm table-hover" style="width:100%"></table>
        </div>
      </div>
    </div>
    `;
    return view;
  },
  after_render: async () => {
    Array.from(document.getElementsByClassName("loader")).forEach((x) => (x.style.display = "block"));
    document.getElementById("loadtime").textContent = "";
    let startTime = new Date();

    let tableStorageAccount = utils.getDropDownValue(document.getElementById("storage-account"));
    let sasToken = await utils.getSasToken(tableStorageAccount);
    if (!sasToken) {
      console.error(`No SAS token found for selected storage account, please configure`);
      return;
    }
    let tableService = azure.createTableServiceWithSas(tableStorageAccount, sasToken);
    let getCampaignsQuery = new azure.TableQuery().where("PartitionKey eq ?", "");
    console.log("Table storage query:", getCampaignsQuery);

    queryEntitiesSegmented(tableService, getCampaignsQuery, null, [], startTime);
  },
};

const queryEntitiesSegmented = (tableService, query, token, entries, startTime) => {
  let selectedTenant = utils.getDropDownValue(document.getElementById("tenant"));
  tableService.queryEntities(`${selectedTenant}Campaigns`, query, token, function (error, result, response) {
    if (error) throw error;

    entries.push(...result.entries);

    if (result.continuationToken) {
      queryEntitiesSegmented(tableService, query, result.continuationToken, entries, startTime);
    } else {
      let table = $("#campaigns-table").DataTable({
        pageLength: 25,
        order: [[2, "desc"]],
        data: entries,
        columns: [
          { data: "RowKey._", title: "Campaign ID" },
          { data: null, defaultContent: "", title: "Name" },
          {
            data: "DataLastReceived._",
            title: "Data Last Received",
            render: (d, t, r) => {
              if (t === "display" || t === "filter") {
                return new Date(d).toISOString();
              }
              return d;
            },
          },
        ],
      });

      $("#campaigns-table tbody").on("click", "tr", function () {
        let data = table.row(this).data();
        let dataLastReceivedInDotNetTicks = utils.jsTicksToDotNetTicks(data.DataLastReceived._);
        window.location = `#/campaign/${data.RowKey._}&lastreceived=${dataLastReceivedInDotNetTicks}`;
      });

      // calculate load time
      let endTime = new Date();
      document.getElementById("loadtime").textContent = `${(endTime - startTime) / 1000}s`;
      Array.from(document.getElementsByClassName("loader")).forEach((x) => (x.style.display = "none"));
    }
  });
};

export default index;
